/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IJob {
        jobId: string;
        creationDate: Date;
        jobStatus: string;
        assignedProbe: Models.IProbe;
        jobInfo: Models.IJobInfo;
        jobResult: Models.IJobResult;
        jobType: JobType;
    }

    export interface IJobRequest {
        probeId: number;
        jobInfo: IJobInfo;
    }

    export interface IJobInfo {
        networkElementHref: number;
        networkNode: INetworkNode;
        networkNodeType: INetworkNodeType;
    }

    export interface IJobResult {
    }

    export class JobType {
        public static PORT_SCANNER: string = "PortScanner";
        public static MVP_APP_SCANNER: string = "MVPAppScanner";
    }
    
    export class JobStatus {
        public static CREATED: string = "CREATED";
        public static RUNNING: string = "RUNNING";
        public static FINISHED: string = "FINISHED";
        public static ERROR: string = "ERROR";
    }
}
